import React, { createContext, useState, useEffect } from 'react';
import projectService from '../services/projectService';

export const ProjectContext = createContext();

export const ProjectProvider = ({ children }) => {
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadProject = async (projectId) => {
    try {
      setLoading(true);
      setError(null);
      const projectData = await projectService.getProject(projectId);
      setProject(projectData);
      return projectData;
    } catch (err) {
      setError(err.message || 'Failed to load project');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const value = {
    project,
    loading,
    error,
    loadProject,
    setProject
  };

  return <ProjectContext.Provider value={value}>{children}</ProjectContext.Provider>;
};